import { Badge, Group, Text } from '@mantine/core'

/** `2026.7.35-ai-arm64-5a575e15` -> `2026.7.35 · 5a575e15`: o upstream do OpenClaw e o
 *  commit do build, que é o que distingue duas versões. Forma estranha volta inteira. */
export function tagCurta(tag: string): string {
  const m = /^(.+)-ai-arm64-([0-9a-f]{8})$/.exec(tag)
  return m ? `${m[1]} · ${m[2]}` : tag
}

/**
 * Versão de um gateway (spec 2026-10-15 linha do tempo §10.5). Dado em JetBrains Mono
 * (DS §3.4). "Desatualizado" usa o tom de atenção (`yellow`, DS §2.3), não o de falha:
 * a falha é o job; isto é o estado que o job conserta.
 */
export function VersaoDoGateway({ tag, corrente }: { tag: string; corrente: string }) {
  return (
    <Group gap={6} wrap="nowrap">
      <Text ff="monospace" size="xs" title={tag}>{tagCurta(tag)}</Text>
      {tag !== corrente && (
        <Badge color="yellow" variant="light" title={`Versão corrente: ${corrente}`}>Desatualizado</Badge>
      )}
    </Group>
  )
}
